import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryProductCategory = {
  async productCategory(_parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args
    const { sort } = info.variableValues
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.PRODUCTS,
      operation: Operations.READ,
    })

    if (typeof id !== "string") return null

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    let category
    category = await client.fetch(
      groq`*[_type=="category" && id==$id ${draftsFilter}][0] {
        ...,
        "revId": _id,
        parentCategory->,
        "subCategories": *[_type=="category" && parentCategory._ref == ^._id] | order(${sort})
      }`,
      { id },
    )

    category = {
      ...category,
    }

    return category
  },
}
